import { render, staticRenderFns } from "./XmNewAreaSelect.vue?vue&type=template&id=c31d8082&scoped=true"
import script from "./XmNewAreaSelect.vue?vue&type=script&lang=js"
export * from "./XmNewAreaSelect.vue?vue&type=script&lang=js"
import style0 from "./XmNewAreaSelect.vue?vue&type=style&index=0&id=c31d8082&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c31d8082",
  null
  
)

export default component.exports